<template>
  <section>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="160px"></qx-custom-form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '新登录密码',
            value: 'newLoginPasswd',
            type: 'input',
            placeholder: '6-16位字母或数字',
            attr: {
              type: 'password',
            },
          },
          {
            label: '确认登录密码',
            value: 'confirmLoginPasswd',
            type: 'input',
            placeholder: '6-16位字母或数字',
            attr: {
              type: 'password',
            },
          },
        ],
        rules: {
          newLoginPasswd: [
            { required: true, message: '请输入新登录密码', trigger: 'blur' },
            { validator: this.checkPwd, trigger: 'blur' },
          ],
          confirmLoginPasswd: [
            { required: true, message: '请输入确认登录密码', trigger: 'blur' },
            { validator: this.checkPwd, trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        if (formData.newLoginPasswd !== formData.confirmLoginPasswd) {
          this.$message.warning('两次输入的密码不一致！');
          return null;
        }
        formData = {
          ...formData,
          password: this.encode(formData.newLoginPasswd),
          confirmPwd: this.encode(formData.confirmLoginPasswd),
        };
      }
      return formData;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
